<div class="recap-dialog">
  @if (!!scenario) {
    <div class="header">
      <span class="text-white" [ghs-label]="'%game.scenarioNumber:' + scenario.index + '%'"></span>
      <span class="text-white" [ghs-label]="gameManager.scenarioManager.scenarioTitle(scenario)"></span>
    </div>
  }
  <div class="scroll-container">
    <ghs-scenario-recap [scenario]="scenario" [forceAll]="forceAll"></ghs-scenario-recap>
  </div>
</div>
